(function documentControllerDefinition() {
    'use strict';

    angular.module('Document')
        .controller('DocumentFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'documentService', 'authExtend', '$rootScope', 'documentContainerService', 'alerts', 'storageService', 'fileDownloader', 'fileService', 'documentAction', 'documentTypeService', 'workflowService', '$filter',
            function documentTypeController($scope, config, $state, $translate, errors, documentService, authExtend, $rootScope, documentContainerService, alerts, storageService, fileDownloader, fileService, documentAction, documentTypeService, workflowService, $filter) {
                $scope.downloadBtn = authExtend.isInRole('FILE DOWNLOAD');
                $scope.viewPDFBtn = authExtend.isInRole('FILE READ');
                $scope.versionView = authExtend.isInRole('DOCUMENTVERSION READ');
                $scope.checkInVersioned = authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                $scope.accesCheckIn = authExtend.isInRole('DOCUMENT WRITE');
                $scope.modifyOptions = $scope.accesCheckIn || $scope.checkInVersioned;
                $scope.containerOptions = authExtend.isInRole('DOCUMENTCONTAINER WRITE') && authExtend.isInRole('ASSOCIATE CONTAINERS');
                $scope.deleteBtn = authExtend.isInRole('DOCUMENT DELETE');
                $scope.deleteMultipleBtn = authExtend.isInRole('DELETE MULTIPLE DOCUMENTS');
                $scope.deleteAttachmentBtn = authExtend.isInRole('DELETE ATTACHMENT');
                $scope.deleteMultipleAttachmentBtn = authExtend.isInRole('DELETE MULTIPLE ATTACHMENT');
                $scope.canStartWorkflow = authExtend.isInRole('WORKFLOW START PROCESS');
                $scope.shareBtn = true;
                $scope.accordionOpened = false;
                $scope.panelOpen = true;
             
                $scope.orders = [
                    { value: 'LastModifiedDate ASC', description: 'LastModifiedDate ASC' },
                    { value: 'LastModifiedDate DESC', description: 'LastModifiedDate DESC' },
                    { value: 'Name ASC', description: 'Name ASC' },
                    { value: 'Name DESC', description: 'Name DESC' }
                ];

                $scope.order = $scope.orders[1];

                $scope.fillAccordion = function () {

                    $scope.items.forEach(function (item) {
                        item.accordionIsOpen = false;
                    });
                };

                $scope.loadActions = function () {
                    // guardo la data en cada registro por que cada documento puede ser de distinto type
                    $scope.items.forEach(function (docu) {
                        if (docu.documentDocumentTypes.length > 0) {
                            documentTypeService.isDoctypeInRole(['FILE DOWNLOAD'], docu.documentDocumentTypes[0].documentTypeId).then(function (r) { docu.downloadBtn = r; });
                            documentTypeService.isDoctypeInRole(['FILE READ'], docu.documentDocumentTypes[0].documentTypeId).then(function (r) { docu.viewPDFBtn = r; });
                            documentTypeService.isDoctypeInRole(['DOCUMENTVERSION READ'], docu.documentDocumentTypes[0].documentTypeId).then(function (r) { docu.versionView = r; });
                            documentTypeService.isDoctypeInRole(['DOCUMENTVERSIONED WRITE'], docu.documentDocumentTypes[0].documentTypeId).then(function (r) { docu.checkInVersioned = r; });
                            documentTypeService.isDoctypeInRole(['DOCUMENT WRITE'], docu.documentDocumentTypes[0].documentTypeId).then(function (r) { docu.accesCheckIn = r; });
                            documentTypeService.isDoctypeInRole(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE'], docu.documentDocumentTypes[0].documentTypeId).then(function (r) { docu.modifyOptions = r; });
                            documentTypeService.isDoctypeInRole(['DOCUMENT DELETE'], docu.documentDocumentTypes[0].documentTypeId).then(function (r) { docu.deleteBtn = r; });
                            documentTypeService.isDoctypeInRole(['DELETE ATTACHMENT'], docu.documentDocumentTypes[0].documentTypeId).then(function (r) { docu.deleteAttachmentBtn = r; });
                        }
                    });
                }

                $scope.documentTypes = [];

                $scope.findAction = function () {
                    $scope.items = [];
                    $scope.checkAll = false;
                    $scope.find.showNoData = false;
                    $scope.documentTypeIds = [];
                    
                    $scope.find.documentTypes.forEach(function (dt) {
                        if (dt.checked) {
                            $scope.documentTypeIds.push(dt.documentTypeId);
                        }
                    });

                    storageService.setMyDocumentFilter($scope.find);
                    return documentService.getCheckedOut($scope.find.name, $scope.userId, $scope.data.currentPage, $scope.data.itemsPerPage, $scope.order.value, $scope.documentTypeIds).then(function getOk(result) {
                        $scope.items = result.value.documents;
                        $scope.find.documentTypes = result.value.documentTypes;
                        $scope.loadActions($scope.items);

                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = result.from;

                        if ($scope.items.length === 0)
                            $scope.find.showNoData = true;

                        if ($scope.items.length > 0) {
                            $scope.fillAccordion();
                        }

                        $scope.find.documentTypes.forEach(function (item) {
                            if ($scope.documentTypeIds.length === 0) {
                                item.checked = true;
                                $scope.dtAllChecked = true;
                            }
                            else {
                                var dtFound = $filter('filter')($scope.documentTypeIds, item.documentTypeId, true);
                                if (dtFound.length > 0) {
                                    item.checked = true;
                                }
                            }
                        });

                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.fillDocMetadata = function (document) {

                    if (document.documentTypes === undefined) {
                        return documentService.getById(document.id, true).then(function (result) {
                            document.documentTypes = result.documentTypes;

                            document.documentTypes.forEach(function (docType) {
                                docType.metadatas.sort(function (a, b) {
                                    return a.position - b.position;
                                });
                            });

                            document.hasMetadata = ($scope.metadataCount(document) !== 0);
                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                    }
                }

                $scope.init = function () {
                    $scope.find = storageService.getMyDocumentFilter();
                    $scope.checkAll = false;
                    $scope.dtAllChecked = storageService.getDtAllCheckedFilter();

                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });

                    $scope.userId = authExtend.getUserId();
                    $scope.items = [];

                    $scope.findAction();
                }

                $scope.add = function () {
                    storageService.setStateBackFind('document-find');
                    $state.go('document-add');
                };

                $scope.addMultiple = function () {
                    storageService.setStateBackFind('document-find');
                    $state.go('document-add-multiple');
                };

                $scope.associateContainer = function () {
                    var checkDocs = [];

                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            if (docu.check) {
                                checkDocs.push(docu);
                            }
                        });
                    }

                    if (checkDocs.length <= 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    documentContainerService.setState('document-find');
                    documentContainerService.setDocuments(checkDocs);
                    $state.go('document-container-associate');
                };

                $scope.view = function (document) {
                    storageService.setStateBackFind('document-find');
                    $state.go('mydocument-detail', { id: document.id });
                };

                $scope.checkInDocument = function (document) {
                    return documentAction.checkIn(document).then(function (doc) {
                        if ($scope.items.length === 1) {
                            $scope.clearFilters();
                        }
                        $scope.findAction();
                    });
                };

                $scope.startWFAndCheckIn = function (document) {
                    return documentAction.startWFAndCheckIn(document).then(function (result) {
                        if ($scope.items.length === 1) {
                            $scope.clearFilters();
                        }
                        $scope.findAction();
                    }, function (error) {
                        errors.showError(error);
                        $scope.load();
                    });
                };

                $scope.deleteDocument = function (document) {
                    return documentAction.deleteDocument(document).then(function (doc) {
                        $scope.findAction();
                    });
                };

                $scope.deleteVersion = function (document) {
                    return $translate(['Warning', 'DocumentVersionDeleteConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentVersionDeleteConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (result) {
                                return documentService.deleteVersion(document).then(function getOk(result) {
                                    errors.showSuccess('DocumentVersionDeleteSucces');
                                    $scope.findAction();
                                }, function (error) {
                                    errors.showError(error);
                                    $scope.load();
                                });
                            }
                        });
                    });
                };

                $scope.deleteMultipleDocuments = function () {

                    $scope.documentIds = [];

                    if ($scope.items.length > 0) {
                        for (var i = 0; i < $scope.items.length; i++) {
                            if ($scope.items[i].check) {
                                $scope.documentIds.push($scope.items[i].id);
                            }
                        }
                    }

                    if ($scope.documentIds.length == 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    return $translate(['Warning', 'DocumentDeleteDocumentsConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentDeleteDocumentsConfirmText, translated.Yes, translated.No).then(function (result) {
                            if (!result) {
                                return result;
                            }

                            return documentService.deleteMultiple($scope.documentIds).then(function (result) {
                                errors.showSuccess('DocumentMultipeDocumentsDeleteSuccess');
                                $scope.findAction();
                            }, function (error) {
                                // If we have a satus 400 we should  show the DeleteMultipleError error message.
                                if (error.status == 400)
                                    errors.showError('DeleteMultipleError');
                                else
                                    errors.showError(error);
                                $scope.findAction();
                            });
                        });
                    });
                };

                $scope.deleteAttachments = function (document) {

                    $scope.documentIds = [];
                    $scope.documentIds.push(document.id);

                    return $translate(['Warning', 'DocumentDeleteAttachmentsConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentDeleteAttachmentsConfirmText, translated.Yes, translated.No).then(function (result) {
                            if (!result) {
                                return result;
                            }

                            return documentService.deleteAttachments($scope.documentIds).then(function (result) {
                                errors.showSuccess('DocumentDeleteAttachmentsSuccess');
                                $scope.findAction();
                            }, function (error) {
                                errors.showError(error);
                            });
                        });
                    });
                };

                $scope.deleteMultipleAttachments = function () {
                    $scope.documentIds = [];

                    if ($scope.items.length > 0) {
                        for (var i = 0; i < $scope.items.length; i++) {
                            if ($scope.items[i].check) {
                                $scope.documentIds.push($scope.items[i].id);
                            }
                        }
                    }

                    if ($scope.documentIds.length == 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    return $translate(['Warning', 'DocumentDeleteAttachmentDocumentsConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.DocumentDeleteAttachmentDocumentsConfirmText, translated.Yes, translated.No).then(function (result) {
                            if (!result) {
                                return result;
                            }

                            return documentService.deleteAttachments($scope.documentIds).then(function (result) {
                                errors.showSuccess('DocumentDeleteAttachmentsSuccess');
                                $scope.findAction();
                            }, function (error) {
                                // If we have a satus 400 we should  show the DeleteMultipleError error message.
                                if (error.status == 400)
                                    errors.showError('DeleteMultipleAttachmentsError');
                                else
                                    errors.showError(error);
                                $scope.findAction();
                            });
                        });
                    });
                };

                $scope.checkInAll = function () {
                    var checkDocs = [];
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            if (docu.check) {
                                checkDocs.push(docu);
                            }
                        });
                    }

                    if (checkDocs.length <= 0) {
                        errors.showError('VerifyFormNoDocuments');
                        return;
                    }

                    return $translate(['Warning', 'CheckOutsConfirmText', 'CheckInAllCreateVersionConfirmText', 'Yes', 'No']).then(function (translated) {
                        return alerts.confirm(translated.Warning, translated.CheckOutsConfirmText, translated.Yes, translated.No).then(function getOk(result) {
                            if (!result) {
                                return result;
                            }

                            if ($scope.checkInVersioned && $scope.accesCheckIn) {
                                return alerts.confirm(translated.Warning, translated.CheckInAllCreateVersionConfirmText, translated.Yes, translated.No).then(function (createVersion) {
                                    return documentService.checkInAll(createVersion, checkDocs).then(function () {
                                        errors.showSuccess('DocumentCheckInSucces');
                                        $scope.findAction();
                                    }, function (error) {
                                        // TODO: Se deberían mostrar todos los errores en una ventana. 
                                        // Por ahora se muestra el primero que es el error genérico.
                                        errors.showError(error);
                                        $scope.findAction();
                                    });
                                });
                            } else {
                                return documentService.checkInAll($scope.checkInVersioned, checkDocs).then(function () {
                                    errors.showSuccess('DocumentCheckInSucces');
                                    $scope.findAction();
                                }, function (error) {
                                    // TODO: Se deberían mostrar todos los errores en una ventana. 
                                    // Por ahora se muestra el primero que es el error genérico.
                                    errors.showError(error);
                                    $scope.findAction();
                                });
                            }
                        });
                    });
                };

                $scope.viewPDF = function (document) {
                    storageService.setStateBackFind('document-find');
                    $state.go('myfile-document-detail', { id: document.id });
                };

                $scope.viewVersion = function (document) {
                    storageService.setStateBackFind('document-find');
                    $state.go('document-version-all', { id: document.id });
                };

                $scope.downloadFilesDocument = function (document) {
                    return documentAction.downloadFiles(document);
                }

                $scope.modify = function (document) {
                    storageService.setStateBackFind('document-find');
                    $state.go('document-modify', { id: document.id });
                };

                $scope.checkUnCheckAll = function () {
                    if ($scope.items.length > 0) {
                        $scope.items.forEach(function (docu) {
                            docu.check = $scope.checkAll;
                        });
                    }
                };

                $scope.clearFilters = function () {
                    storageService.clearMyDocumentFilter();
                    storageService.clearDtAllcheckedFilter();
                    $scope.find.documentTypes.forEach(function (item) {
                        item.checked = true;
                    });

                    $scope.find.name = null;
                    $scope.init();
                }

                $scope.toggleAccordion = function (item) {
                    if (item.accordionIsOpen) {
                        $scope.fillDocMetadata(item);
                    }
                };

                $scope.toggleDocTypeCheck = function () {
                    $scope.find.documentTypes.forEach(function (dt) {
                        dt.checked = !$scope.dtAllChecked;
                    });
                    $scope.dtAllChecked = !$scope.dtAllChecked;
                };

                $scope.openAccordion = function () {
                    $scope.accordionOpened = !$scope.accordionOpened;
                    $scope.items.forEach(function (item) {
                        item.accordionIsOpen = $scope.accordionOpened;
                        if (item.accordionIsOpen) {
                            $scope.fillDocMetadata(item);
                        };
                    });
                };

                $scope.showPanel = function () {
                    $scope.panelOpen = true;
                };

                $scope.hidePanel = function () {
                    $scope.panelOpen = false;
                };

                $scope.metadataCount = function (document) {
                    if (document.documentTypes && document.documentTypes.length) {
                        return document.documentTypes.reduce(function (valorPrevio, valorActual, indice, array) { return valorPrevio + valorActual.metadatas.length; }, 0);
                    }
                    return 0;
                };

                $scope.mergeDocuments = function () {

                    $scope.documents = [];

                    if ($scope.items.length > 0) {

                        var countItemsChecked = 0;

                        for (var i = 0; i < $scope.items.length; i++) {
                            if ($scope.items[i].check) {
                                $scope.documents.push($scope.items[i]);

                                countItemsChecked++;

                                if (countItemsChecked > 2) {
                                    break;
                                }
                            }
                        }

                        if (countItemsChecked < 2 || countItemsChecked > 2) {
                            errors.showError('DocumentMustSelectTwoDocumentsToMerge');

                            return;
                        }

                        return documentService.merge($scope.documents).then(function (result) {
                            errors.showSuccess('DocumentMergeSuccess');
                            $scope.init();
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.init();
            }
        ]);
})();